import React from "react";

export const BsPagination = ({page, prev="Previous", next="Next", btnSize}) =>
{
	//if (page.pageMax == 0) {return (<div />);}

	const pageIndex = page.pageIndex;
	const pages = page.pages;

	const onClickButton = (e, p) => {
		e.target.blur();
		page.onClickPage(p);
	};
	
	return (
		<ul className={`pagination ${btnSize ?? "pagination-sm"} m-0 p-1`}>
			<li className="page-item">
				<a className={`page-link ${(pages.length==0 || pageIndex==1) ? 'disabled':''}`} href="#" onClick={(e)=>onClickButton(e, pageIndex-1)}>{prev}</a>
			</li>
			{pages.map((page, idx) => {
				if (page == -1) {
					return <li key={idx} className="page-item"><a className="page-link disabled" href="#">...</a></li>;
				}
				else {
					return <li key={idx} className="page-item"><a className={`page-link ${(page == pageIndex) ? 'active':''}`} href="#" onClick={(e)=>onClickButton(e, page)}>{page}</a></li>;
				}
			})}
			<li className="page-item">
				<a className={`page-link ${(pages.length==0 || pageIndex==page.pageMax) ? 'disabled':''}`} href="#" onClick={(e)=>onClickButton(e, pageIndex+1)}>{next}</a>
			</li>
		</ul>
	);
};